let PURPOSE_OF_TRANSFER_VALUES = [
    {code: "PT01", value: "Business Expenses"},
    {code: "PT02", value: "Credit Card Payment"},
    {code: "PT03", value: "Charity Payment    "},
    {code: "PT04", value: "Dividend"},
    {code: "PT05", value: "Education / Training"},
    {code: "PT06", value: "Payment of Fees & Charges "},
    {code: "PT07", value: "Purchase of Goods and Services"},
    {code: "PT08", value: "Insurance"},
    {code: "PT09", value: "Intra Company Payment   "},
    {code: "PT10", value: "Investment & Securities   "},
    {code: "PT11", value: "Loan / Installment Repayment"},
    {code: "PT12", value: "Medical / Healthcare Services"},
    {code: "PT13", value: "Other"},
    {code: "PT14", value: "Refund"},
    {code: "PT15", value: "Wages / Salary Payment    "},
    {code: "PT16", value: "Payment for Vendors and Suppliers"},
    {code: "PT17", value: "Government Tax Payment"},
    {code: "PT18", value: "Utility Bills Payment"},
    {code: "PT19", value: "Family Expenses"},
    {code: "PT20", value: "Personal Expenses"},
    {code: "PT21", value: "Savings/Retirement"},
    {code: "PT22", value: "Advance Payment"},
    {code: "PT23", value: "Foreign Exchange"},
    {code: "PT24", value: "Refund/Withdrawal"},
]



export var getPurposeOfTransferByCode = (code) => {
    for (let i = 0; i < PURPOSE_OF_TRANSFER_VALUES.length; i++) {
        let val = PURPOSE_OF_TRANSFER_VALUES[i];
        if (val.code === code) {
            return val.value;
        }
    }
    return null;
}

export var ALL_PURPOSE_OF_TRANSFER_VALUES = PURPOSE_OF_TRANSFER_VALUES;
